import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hotel",
  "use": "icon-hotel-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\" id=\"icon-hotel\">\n    \n    <g>\n    <path d=\"M22.667 25.333h2.667v-10.667h-8v10.667h2.667v-8h2.667v8zM4 25.333v-20c0-0.736 0.597-1.333 1.333-1.333v0h18.667c0.736 0 1.333 0.597 1.333 1.333v0 6.667h2.667v13.333h1.333v2.667h-26.667v-2.667h1.333zM9.333 14.667v2.667h2.667v-2.667h-2.667zM9.333 20v2.667h2.667v-2.667h-2.667zM9.333 9.333v2.667h2.667v-2.667h-2.667z\" />\n    </g>\n  </symbol>"
});
var result = sprite.add(symbol);
export default symbol